/** @format */
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ModelSearchResultsType } from '@toucan/common/services/search/constants';
import { getModelSearchResults } from '@toucan/common/services/search/model/helpers';
import {
    ModelSearchResultsSearchParams,
    Query,
} from '@toucan/common/services/search/types';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';

export const useModelPaginatedResults = (
    queryKey: string,
    isInfiniteScroll: boolean,
    resultsPerPage: number,
    baseQuery: Partial<Query>,
    searchParams: ModelSearchResultsSearchParams,
    type: ModelSearchResultsType
) => {
    const { activeMarket } = useContext(MarketContext);

    const pageIndex = searchParams.pageIndex;
    const start = pageIndex * resultsPerPage;
    const rows = resultsPerPage;

    return useQuery({
        enabled: !isInfiniteScroll,
        queryKey: ['modelSearchResults', type, queryKey],
        queryFn: async () => {
            const results = await getModelSearchResults(
                baseQuery,
                searchParams,
                start,
                rows,
                activeMarket
            );

            return results;
        },
        refetchOnWindowFocus: false,
        staleTime: Milliseconds.FIVE_MINUTES,
    });
};
